import React from 'react';
import {StyledPrimaryTextButton} from './StyledPrimaryTextButton';

const PrimaryTextButton = ({
  children,
  ...rest
}) => {
  return (
    <StyledPrimaryTextButton
      size='middle'
      type='text'
      {...rest}
    >
      {children}
    </StyledPrimaryTextButton>
  );
}

export default PrimaryTextButton;
